export type TableSortDirection = 'asc' | 'desc' | null

/** Tooltip / aria-label for the next click in the 3-state column sort cycle. */
export function tableSortNextActionLabel(direction: TableSortDirection): string {
  if (direction === 'asc') return 'Click to sort Z-A'
  if (direction === 'desc') return 'Click to clear sort'
  return 'Click to sort A-Z'
}
